/**
 * "+ Nova Organização", logo abaixo do seletor "Organização ativa" da Sidebar (spec 2026-10-27
 * §4.4). Quem decide se aparece é o servidor, pela disponibilidade do tenant atual: `pedir` ou
 * `criar` mostra, `null` esconde.
 */
import { useState } from 'react'
import { Box, Button } from '@mantine/core'
import { IconPlus } from '@tabler/icons-react'
import { useQuery } from '@tanstack/react-query'
import { chaveDaDisponibilidade, lerDisponibilidade } from '@/api/pedidosDeOrganizacao'
import { ModalNovaOrganizacao } from './ModalNovaOrganizacao'

export function BotaoNovaOrganizacao({ tenantId }: { tenantId: number | null }) {
  const [aberto, setAberto] = useState(false)
  const { data: disponibilidade } = useQuery({
    queryKey: chaveDaDisponibilidade(tenantId),
    queryFn: () => lerDisponibilidade(tenantId!),
    enabled: tenantId != null,
    staleTime: 5 * 60_000,
    retry: false,
  })

  if (tenantId == null || !disponibilidade?.acao) return null

  return (
    <Box style={{ padding: '0 15px 6px' }}>
      <Button
        size="compact-xs"
        variant="subtle"
        color="gray"
        c="gray.4"
        fullWidth
        justify="flex-start"
        leftSection={<IconPlus size={12} />}
        onClick={() => setAberto(true)}
      >
        Nova Organização
      </Button>
      {/* Montado só quando aberto: não busca gestores à toa e reabre com o formulário limpo. */}
      {aberto && (
        <ModalNovaOrganizacao
          opened
          onClose={() => setAberto(false)}
          tenantId={tenantId}
          disponibilidade={disponibilidade}
        />
      )}
    </Box>
  )
}
